import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerV2InitialState, basedDataReducerV2 } from 'redux/base-reducer-v2';

import { ProductionDevice } from '../types/eecs-production-device.types';

export interface ProductionDevicesInitialState extends BaseDataReducerV2InitialState<ProductionDevice> {
  perPage: number;
  editingDevice: ProductionDevice | null;
}

const { initialState, AC, reducer, thunks } = basedDataReducerV2<ProductionDevice, ProductionDevicesInitialState>(
  'necs-production-devices',
);

export const productionDevicesInitialState: ProductionDevicesInitialState = {
  ...initialState,
  perPage: 25,
  editingDevice: null,
  filters: {
    hasCertificates: 1,
  },
};

export const productionDevice = createSlice({
  name: 'productionDevice',
  initialState: productionDevicesInitialState,
  reducers: {
    setEditingProductionDevice: (state, action: PayloadAction<ProductionDevice | null>) => {
      state.editingDevice = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as ProductionDevicesInitialState, action);
    });
  },
});

export const ProductionDeviceAC = AC;
export const onProductionDeviceSort = thunks.onSort;
export const onProductionDeviceFilter = thunks.onFilter;
export const clearProductionDeviceFilters = AC.clearFilters;
export const setProductionDeviceCurrentPage = AC.setCurrentPage;

export const { setEditingProductionDevice } = productionDevice.actions;
